<template>
  <div>
    <button
      class="dimension-control"
      data-test="dimension-button"
      @click="handleToggle"
    >
      <div class="dimension">
        <ys-text type="metadata1-bold">3D</ys-text>
      </div>
      <div :class="['dimension-selected', { 'three-d': isViewer3d }]">
        <ys-text type="metadata1-bold" data-test="label">
          {{ label }}
        </ys-text>
      </div>
    </button>
    <dimension-upsell
      v-if="showUpsell"
      data-test="upsell-modal"
      @close="showUpsell = false"
    />
  </div>
</template>
<script setup lang="ts">
///// imports /////
import { computed, ref } from 'vue'
import '@onxmaps/yellowstone-ui/ys-text'

import {
  viewer3d,
  setMarketingToggled3D,
  toggle3d,
} from '@/services/map-service'
import marketingEventService from '@/services/marketing-event-service'
import dimensionUpsell from '@/fish/components/map-controls/dimension-upsell.vue'
import subscriptionService from '@/services/subscription-service'

///// refs and variables /////
const showUpsell = ref(false)

///// computed /////
const isViewer3d = computed(viewer3d)
const label = computed(() => (isViewer3d.value ? 'On' : 'Off'))
const isBasicUser = computed(() => subscriptionService.isBasic())

///// functions /////
const handleToggle = () => {
  if (isBasicUser.value) {
    showUpsell.value = true
    return
  }

  setMarketingToggled3D(true)
  const event = isViewer3d.value ? '3d_disabled' : '3d_enabled'
  marketingEventService.setEventValues(event, {
    origin: 'button',
  })
  toggle3d()
}
</script>
<style lang="scss" scoped>
@use '@/styles/system/_shadow.scss';

.dimension-control {
  width: 45px;
  height: 45px;
  padding: var(--ys-spacing-50);
  text-align: center;
  cursor: pointer;
  background: var(--ys-color-background-primary);
  border-radius: 10px;
  user-select: none;
  box-shadow: shadow.$Low;
}

.dimension {
  color: var(--ys-color-text-primary);
}

.dimension-selected {
  width: 100%;
  background-color: var(--ys-color-surface-secondary);
  color: var(--ys-color-text-primary);
  border-radius: var(--ys-radius-25) var(--ys-radius-25) var(--ys-radius-100)
    var(--ys-radius-100);
  flex-shrink: 0;
  transition:
    background-color 250ms ease,
    color 250ms ease;

  &.three-d {
    background-color: var(--ys-color-brand-primary);
    color: var(--ys-color-text-constant-primary);
  }
}
</style>
